export default "__VITE_ASSET__hAFpEern__"